<template>
  <li>
    <div
        class="folder-line"
        :class="{ active: isSelected }"
        :style="{ paddingLeft: (node.level * 15) + 'px' }"
    >
      <!-- Toggle icon -->
      <!-- Niveau 0 : ajoute une icône vide si pas d’enfant -->
      <span v-if="hasChildren"
            class="toggle-icon">
        <i :class="icon(node.open)" @click="toggle()"/>
</span>

      <span v-else-if="node.level === 0" class="toggle-placeholder" style="padding-left: 15px"></span>

      <!-- Folder name -->
      <span class="folder-name" @click="selectFolder">
        {{ node.name }}
      </span>
    </div>

    <!-- Children -->
    <ul v-if="hasChildren && node.open" class="folder-sub">
      <folder-node
          v-for="child in node.children"
          :key="child.fullName"
          :node="child"
          :selected-folder="selectedFolder"
          @select-folder="$emit('select-folder', $event)"
          @toggle="$emit('toggle', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: "FolderNode",

  props: {
    node: {type: Object, required: true},
    selectedFolder: {type: String, required: false}
  },

  computed: {
    isSelected() {
      return this.node.fullName === this.selectedFolder;
    },
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    }
  },

  methods: {
    icon(node) {
      if (node) {
        return "fas fa-folder-open";
      } else {
        return "fa fa-folder";
      }
    },
    selectFolder() {
      this.$emit("select-folder", this.node.fullName);
    },
    toggle() {
      this.$emit("toggle", this.node);
    }
  }
};
</script>

<style scoped>
.folder-line {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  transition: background 0.2s;
}

.folder-line:hover {
  background: #eef2f2;
}

.folder-line.active {
  background: #7c9c9c;
  color: white;
}

.toggle-icon {
  width: 16px;
  display: inline-block;
  margin-right: 4px;
  cursor: pointer;
  font-size: 14px;
}

.folder-name {
  flex: 1;
}

.folder-sub {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
